module.exports = __webpack_public_path__ + "static/media/error_404.02746527.png";